import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormControl, Button } from 'react-bootstrap';

import { parseCoordinates, getGoogleMapsUrl } from '../../helpers/coordinatesParser';
import messages from '../../locale/messages';

import s from './CoordinatesInput.css';

class CoordinatesInput extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    change: PropTypes.func.isRequired,
    value: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      parsedData: {
        lat: null,
        lng: null,
        isValid: false,
        error: null
      }
    };
  }

  componentDidMount() {
    // Load initial coordinates from Redux form if they exist
    const { lat, lng } = this.props;
    if (lat && lng) {
      const inputValue = `${lat}, ${lng}`;
      const parsedData = parseCoordinates(inputValue);
      this.setState({
        inputValue,
        parsedData
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Update if lat/lng change from outside (e.g., loaded from DB)
    const { lat, lng } = this.props;
    const { lat: prevLat, lng: prevLng } = prevProps;

    if ((lat !== prevLat || lng !== prevLng) && lat && lng) {
      const inputValue = `${lat}, ${lng}`;
      const parsedData = parseCoordinates(inputValue);

      // Only update if different from current state
      if (this.state.inputValue !== inputValue) {
        this.setState({
          inputValue,
          parsedData
        });
      }
    }
  }

  handleInputChange = (e) => {
    const { change } = this.props;
    const inputValue = e.target.value;

    // Parse coordinates
    const parsedData = parseCoordinates(inputValue);

    // Update local state
    this.setState({
      inputValue,
      parsedData
    });

    // Update form fields
    if (parsedData.isValid) {
      change("ListPlaceStep1", "lat", parsedData.lat);
      change("ListPlaceStep1", "lng", parsedData.lng);
      change("ListPlaceStep1", "isMapTouched", true);
    } else {
      change("ListPlaceStep1", "lat", null);
      change("ListPlaceStep1", "lng", null);
      change("ListPlaceStep1", "isMapTouched", false);
    }
  };

  handleTestLocation = () => {
    const { parsedData } = this.state;
    if (parsedData.isValid) {
      const url = getGoogleMapsUrl(parsedData.lat, parsedData.lng);
      window.open(url, '_blank');
    }
  };

  render() {
    const { inputValue, parsedData } = this.state;
    const { isValid, error, lat, lng } = parsedData;
    const { intl } = this.props;

    return (
      <div className={s.container}>
        <div className={s.inputGroup}>
          <FormControl
            type="text"
            value={inputValue}
            onChange={this.handleInputChange}
            placeholder={intl.formatMessage(messages.coordinatesPlaceholder)}
            className={cx(s.input, {
              [s.inputValid]: isValid,
              [s.inputError]: error && inputValue
            })}
          />
          {isValid && (
            <Button
              onClick={this.handleTestLocation}
              className={cx(s.testButton)}
            >
              <FormattedMessage {...messages.coordinatesTestButton} />
            </Button>
          )}
        </div>

        {/* Feedback messages */}
        {isValid && (
          <div className={cx(s.feedback, s.feedbackSuccess)}>
            ✓ <FormattedMessage {...messages.coordinatesSuccessMessage} />: {lat.toFixed(6)}, {lng.toFixed(6)}
          </div>
        )}

        {error && inputValue && (
          <div className={cx(s.feedback, s.feedbackError)}>
            ✗ {error}
          </div>
        )}

        {!inputValue && (
          <div className={s.helpText}>
            <FormattedMessage {...messages.coordinatesPlaceholder} />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s)(connect(null, mapDispatch)(CoordinatesInput)));
